import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TflStationsIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<g clipPath='url(#clip0_41_2097)'>
				<circle
					cx='12'
					cy='12'
					fill='white'
					r='10'
					stroke={props?.color || 'currentColor'}
					strokeWidth='4'
				/>
				<path
					d='M22.0279 10H1.97209C0.882937 10 0 10.8829 0 11.9721C0 13.0613 0.882938 13.9442 1.9721 13.9442H22.0279C23.1171 13.9442 24 13.0613 24 11.9721C24 10.8829 23.1171 10 22.0279 10Z'
					fill={props?.color || 'currentColor'}
				/>
				<path
					d='M7.6419 11.3138H7.05705V12.9866H6.66237V11.3138H6.07593V10.9627H7.6419V11.3138Z'
					fill='white'
				/>
				<path
					d='M9.12679 11.3138H8.28241V11.7387H8.9506V12.0945H8.28241V12.9866H7.88806V10.9627H9.12679V11.3138Z'
					fill='white'
				/>
				<path
					d='M10.6027 12.9866H9.36401V10.9627H9.75837V12.6158H10.6027V12.9866Z'
					fill='white'
				/>
				<path
					d='M12.4476 11.3046V11.8369H12.6359C12.7523 11.8369 12.8426 11.8121 12.9072 11.7619C12.9714 11.7123 13.0035 11.6439 13.0035 11.5568C13.0035 11.4785 12.9746 11.4175 12.9161 11.3729C12.8579 11.3287 12.7768 11.3058 12.6731 11.3046H12.4476ZM13.6523 12.9866H13.1886L12.6299 12.1791H12.4476V12.9866H12.0536V10.963H12.7087C12.9202 10.963 13.0878 11.0158 13.2118 11.122C13.3356 11.2282 13.3976 11.3717 13.3976 11.5536C13.3976 11.6786 13.3645 11.787 13.298 11.8802C13.2319 11.974 13.1378 12.043 13.015 12.0882L13.6523 12.9866Z'
					fill='white'
				/>
				<path
					d='M14.9737 12.2399L14.6907 11.4931L14.4121 12.2399H14.9737ZM15.6868 12.9866H15.2555L15.1105 12.5983H14.2792L14.1322 12.9866H13.7086L14.4852 10.963H14.9L15.6868 12.9866Z'
					fill='white'
				/>
				<path
					d='M16.3063 10.962H15.9106V12.9863H16.3063V10.962Z'
					fill='white'
				/>
				<path
					d='M17.9212 12.9866H16.6822V10.9627H17.0768V12.6158H17.9212V12.9866Z'
					fill='white'
				/>
				<path
					d='M11.1685 12.2469L10.9017 11.9797L11.1685 11.7088L11.4392 11.9797L11.1685 12.2469Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_41_2097'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default TflStationsIcon;
